<div class="dialogContainer" [ngClass]="{'visible': showDialog }">
  <div class="dialog">
    @if (message) {
      <div class="message"  [innerHtml]="message | safeHtml"></div>
    }
    @if (dialog?.hasParam) {
      <div class="grid-x margin-top" [formGroup]="form">
        @for (ctrl of controls; track ctrl) {
          @if (controlIsVisible(ctrl.id)) {
            <div class="cell small-4 text-align-right padding-right">
              {{ctrl.label}}@if (ctrl.validators?.length > 0) {
              <span [ngClass]="{ 'red': form?.get(ctrl.id)?.invalid }">*</span>
              }:
            </div>
            <div class="cell small-8 text-align-left">
              @switch (ctrl.type) {
                @case (types.Text) {
                  <input type="text" [formControlName]="ctrl.id" />
                }
                @case (types.Number) {
                  <input type="number" [formControlName]="ctrl.id" />
                }
                @case (types.Dropdown) {
                  <select [id]="ctrl.id" [formControlName]="ctrl.id" (change)="updateControlOptions($event)">
                    @for (opt of ctrl.options; track opt) {
                      <option [value]="opt.id">{{opt.text}}</option>
                    }
                  </select>
                }
                @case (types.Checkbox) {
                  <input type="checkbox" [formControlName]="ctrl.id" [id]="ctrl.id" (click)="checkboxChanged($event)" />
                }
                @case (types.TextEditor) {
                  <div [id]="ctrl.id" [formControlName]="ctrl.id" [froalaEditor]="froalaOptions"></div>
                }
                @case (types.Date) {
                  <common-date-picker [id]="ctrl.id" [initialDate]="form.get(ctrl.id).value" (controlUpdated)="onDateChanged($event)" [controlName]="ctrl.id"></common-date-picker>
                }
              }
            </div>
          }
        }
      </div>
    }
    @if (dialog?.isTabular) {
      <ag-grid-angular [gridOptions]="dialog.gridOptions" [rowData]="dialog.rows" class="data-grid " [excelStyles]="excelStyles" aria-label="Dynamic Dialog"></ag-grid-angular>
    }
    <div class="dialogButtonsContainer">
      <div class="text-align-center">
        @for (button of dialog.buttons; track button) {
          <button class="button margin-left no-margin-bottom outline-offset-1" [disabled]="dialog?.hasParam == true && form?.invalid && button.isConfirm" (click)="invokeButton(button)">{{button.text}}</button>
        }
      </div>
    </div>
  </div>
</div>